import { useEffect, useState } from 'react'

import { AWXCardholderStatus } from '@ankor-io/common/types/awx'
import type { CardholderSummary } from '@ankor-io/common/types/cards'

import { Field, Label } from '@/ui-components/Fieldset'
import { Input } from '@/ui-components/Input'
import { Select } from '@/ui-components/Select'

type UserSelectStepProps = {
  value: string
  invitedUser: string
  setInvitedUser: (val: string) => void
  cardholders?: CardholderSummary[]
  preselectedCardholder?: CardholderSummary
}

export const UserSelectStep = ({
  value,
  invitedUser,
  setInvitedUser,
  cardholders,
  preselectedCardholder,
}: UserSelectStepProps) => {
  const [inviteMode, setInviteMode] = useState(false)

  useEffect(() => {
    if (
      !value ||
      preselectedCardholder?.identity.email ||
      cardholders?.some((cardholder) => cardholder.identity.email === value)
    ) {
      setInviteMode(false)
    } else {
      setInviteMode(true)
    }
  }, [value, cardholders, preselectedCardholder])

  const cardholderStatus = (cardholder: CardholderSummary) => {
    switch (cardholder.status) {
      case AWXCardholderStatus.READY:
        return
      case AWXCardholderStatus.PENDING:
        return 'Pending'
      case AWXCardholderStatus.DISABLED:
        return 'Disabled'
      case AWXCardholderStatus.INCOMPLETE:
        return 'Incomplete'
      default:
        return 'Unknown'
    }
  }

  return (
    <Field>
      <Label htmlFor="userSelect">Allocate card to user</Label>
      {!inviteMode ? (
        <>
          <Select
            id="userSelect"
            value={preselectedCardholder?.identity.email || value}
            disabled={!!preselectedCardholder?.identity.email}
            onChange={(e) => setInvitedUser(e.target.value)}
          >
            {preselectedCardholder ? (
              <option value={preselectedCardholder.identity.email}>
                {preselectedCardholder.identity.firstName} {preselectedCardholder.identity.lastName} (
                {preselectedCardholder.identity.email})
              </option>
            ) : (
              <>
                <option value="">Select user</option>
                {cardholders?.map((cardholder) => (
                  <option
                    key={cardholder.id}
                    value={cardholder.identity.email}
                    disabled={cardholder.status !== AWXCardholderStatus.READY}
                  >
                    {cardholder.identity.firstName} {cardholder.identity.lastName} ({cardholder.identity.email}){' '}
                    {cardholderStatus(cardholder) && `(${cardholderStatus(cardholder)})`}
                  </option>
                ))}
              </>
            )}
          </Select>
        </>
      ) : (
        <>
          <Input
            type="email"
            placeholder="newuser@email.com"
            value={invitedUser}
            onChange={(e) => setInvitedUser(e.target.value)}
            required
            autoFocus
          />
          <button
            type="button"
            className="text-sm text-muted-foreground cursor-pointer underline text-primary-600 dark:text-primary-300"
            onClick={() => setInviteMode(false)}
          >
            Back to existing users
          </button>
        </>
      )}
    </Field>
  )
}

export default UserSelectStep
